<template>
  <ReadinessDashboard
    title="US EO 14028 Readiness"
    subtitle="Executive Order 14028 & M-22-18 — secure software attestation posture"
    endpoint-path="eo14028-readiness"
    :actions="actions"
    :category-order="categoryOrder"
  />
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import ReadinessDashboard from '../components/ReadinessDashboard.vue'

export default {
  name: 'EO14028DashboardView',
  components: { ReadinessDashboard },
  setup() {
    const store = useStore()
    const route = useRoute()
    const tenantId = computed(() => route.params.tenantId || store.getters.currentTenantId)

    const actions = computed(() => {
      const t = tenantId.value
      if (!t) return {}
      return {
        products_defined:  { route: `/tenants/${t}/products`,        label: 'Add Product' },
        sbom_coverage:     { route: `/tenants/${t}/products`,        label: 'Upload SBOMs' },
        sbom_format:       { route: `/tenants/${t}/products`,        label: 'Review SBOMs' },
        vuln_disclosure:   { route: `/tenants/${t}/vulnerabilities`, label: 'Manage Vulns' },
        security_contact:  { route: `/tenants/${t}/products`,        label: 'Set Contact' },
        vdp:               { route: `/tenants/${t}/settings`,        label: 'Enable VDP' },
        attestation:       { route: `/tenants/${t}/documents`,       label: 'Upload Attestation' },
        customer_access:   { route: `/tenants/${t}/customer-access`, label: 'Grant Access' },
        public_docs:       { route: `/tenants/${t}/documents`,       label: 'Publish Docs' },
      }
    })

    const categoryOrder = [
      'SBOM & Provenance',
      'Secure Development',
      'Vulnerability Disclosure',
      'Customer Transparency',
      'Attestation',
      'Documentation'
    ]

    return { actions, categoryOrder }
  }
}
</script>
